import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AlertProvider } from './context/AlertContext';
import Header from './components/Header';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import Home from './pages/Home';
import Team from './pages/Team';
import Dashboard from './pages/Dashboard';
import Scholarships from './pages/Scholarships';
import Mentors from './pages/Mentors';
import Community from './pages/Community';
import Library from './pages/Library';
import Profile from './pages/Profile';
import Portfolio from './pages/Portfolio';
import Admin from './pages/Admin';
import MentorDashboard from './pages/MentorDashboard';
import ParentCard from './pages/ParentCard';
import ProgressReport from './pages/ProgressReport';
import VerifyCertificate from './pages/VerifyCertificate';

function AppContent() {
  const [showAuth, setShowAuth] = useState(false);
  const location = useLocation();

  const isDashboard = location.pathname === '/dashboard' || location.pathname === '/mentor-dashboard' || location.pathname === '/parent-card' || location.pathname === '/progress';
  const isAdmin = location.pathname === '/admin';
  const isPortfolio = location.pathname.startsWith('/portfolio');
  const isVerifyCertificate = location.pathname === '/verify-certificate';

  const showHeaderFooter = !isDashboard && !isAdmin && !isVerifyCertificate;

  return (
    <div style={{ minHeight: '100vh', background: '#ffffff', position: 'relative' }}>
      <div className="bg-orb orb-1" />
      <div className="bg-orb orb-2" />

      {showHeaderFooter && <Header onLoginClick={() => setShowAuth(true)} />}

      {/* Spacer only for non-dashboard pages */}
      {showHeaderFooter && !isPortfolio && (
        <div style={{ paddingTop: isDashboard ? 0 : 0 }} />
      )}

      <div key={location.pathname} className="page-transition">
        <Routes>
          <Route path="/" element={<Home onAuthClick={() => setShowAuth(true)} />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/mentor-dashboard" element={<MentorDashboard />} />
        <Route path="/parent-card" element={<ParentCard />} />
        <Route path="/progress" element={<ProgressReport />} />
        <Route path="/scholarships" element={
          <div style={{ paddingTop: '6rem', paddingBottom: '5rem', background: '#ffffff', minHeight: '100vh' }}>
            <div className="container"><Scholarships /></div>
          </div>
        } />
        <Route path="/mentors" element={
          <div style={{ paddingTop: '6rem', paddingBottom: '5rem', background: '#ffffff', minHeight: '100vh' }}>
            <div className="container"><Mentors /></div>
          </div>
        } />
        <Route path="/community" element={
          <div style={{ paddingTop: '6rem', paddingBottom: '5rem', background: '#ffffff', minHeight: '100vh' }}>
            <div className="container"><Community /></div>
          </div>
        } />
        <Route path="/library" element={
          <div style={{ paddingTop: '6rem', paddingBottom: '5rem', background: '#ffffff', minHeight: '100vh' }}>
            <div className="container"><Library /></div>
          </div>
        } />
        <Route path="/profile" element={
          <div style={{ paddingTop: '6rem', paddingBottom: '5rem', background: '#ffffff', minHeight: '100vh' }}>
            <div className="container"><Profile /></div>
          </div>
        } />
        <Route path="/portfolio/:id" element={<Portfolio />} />
        <Route path="/team" element={<Team />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/verify-certificate" element={<VerifyCertificate />} />
      </Routes>
      </div>

      {showHeaderFooter && <Footer />}
      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AlertProvider>
          <AppContent />
        </AlertProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
